const SP_BLOCKS = require("../../../universal/spinneybeck/blocks");
const FF_BLOCKS = require("../../../universal/filzfelt/blocks");
const COLORS = require("../../../universal/filzfelt/colors");

// same as /universal/utils/get-colors-used-and-placeholders.js
// one exported for client, one for server - trying to use it in both places wouldn't work
export function getColorsUsedAndPlaceholders({ design, brand }) {
    const usedBlocks = Object.values(design.data).map(block => block.id);
    const blockIds = [... new Set(usedBlocks)];
    const blocks = blockIds.map(id => {
        const block = brand === "filzfelt" ? FF_BLOCKS[id] : SP_BLOCKS[id];
        return {
            id,
            name: block.name,
            placeholderColor: block.placeholderColor,
        };
    });

    // if there are no placeholder colors, return empty array and show usedColors
    const blocksWithPlaceholderColors = blocks.filter(block => block.placeholderColor);
    if (blocksWithPlaceholderColors.length === 0) {
        return [];
    }

    const usedSet = new Set();
    let colorUsed = [];
    for (const { color } of Object.values(design.data)) {
        if (color) {
            usedSet.add(color);
            colorUsed.push(color);
        }
    }
    const usedColors = {};
    for (const { color, id } of Object.values(design.data)) {
        if (color) {
            usedColors[id] = color;
        }
    }

    const blocksWithUsedColors = blocks.map(block => {
        const usedColor = usedColors[block.id] ? COLORS[usedColors[block.id]] : null;
        return {
            ...block,
            usedColor: usedColor,
        };
    });
    return blocksWithUsedColors;
};



// WEBPACK FOOTER //
// ./src/client/lib/utils/get-colors-used-and-placeholders.js